import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  Alert,
  Image,
  ImageBackground,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import {
  finishTransaction,
  getProducts,
  initConnection,
  requestPurchase,
} from "react-native-iap";

import { AppIcons } from "../../assets/images";
import { userAction } from "../../redux/reducers/user";
import { AppTheme } from "../../utils/theme";
import { androidSkus, iosSkus, objectIdToUUID } from "../../utils/contants";
import FastImage from "react-native-fast-image";
import LinearGradient from "react-native-linear-gradient";
import { useAppSelector } from "../../redux/storeHook";
import { ROUTE_NAME } from "../../utils/routes";

const InPurchaseScreenTablet = () => {
  const navigation = useNavigation<NativeStackNavigationProp<any>>();
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [purchaseLoading, setPurchaseLoading] = useState<string | null>(null); // Track loading per product ID
  const { userData } = useAppSelector((s) => s.user);

  useEffect(() => {
    initIAP();
  }, []);

  const initIAP = async () => {
    try {
      setLoading(true);
      await initConnection();
      await fetchProducts();
    } catch (error) {
      console.log("IAP init error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async () => {
    try {
      const result = await getProducts({
        skus: Platform.OS === "ios" ? iosSkus : androidSkus,
      });
      setProducts(result);
      console.log("Products:", result);
    } catch (error) {
      console.log("Fetch products error:", error);
    }
  };


  const onBuyPress = async (productId: string) => {
    // Prevent purchase if global loading or already purchasing this item
    if (!userData?.access_token) {
      Alert.alert("Login", "To purchase coins, you need to log in first.", [
        {
          text: "Login",
          onPress: () => {
            navigation.navigate(ROUTE_NAME.LoginScreen);
          },
        },
        {
          text: "Cancel",
          style: "cancel",
        },
      ]);
      return;
    }
    if (loading || purchaseLoading === productId) {
      return;
    }
    try {
      setPurchaseLoading(productId); // Set per-item loading
      // Platform-specific params for requestPurchase
      const UUID = objectIdToUUID(userData?._id as any);
      console.log("@ obje ctIdToUUID", UUID);
      const purchaseParams =
        Platform.OS === "ios"
          ? { sku: productId, appAccountToken: UUID }
          : { skus: [productId],obfuscatedAccountIdAndroid:userData?._id };

      console.log("Purchase params:", purchaseParams);
      // await requestPurchase(purchaseParams);
      const purchase = await requestPurchase(purchaseParams);
      await completeTransaction(purchase);
      // Note: After requestPurchase, you should listen for purchase updates
      // via addPurchaseListener or getPurchaseUpdatesAsync in a real app
    } catch (error) {
      console.log("Purchase error:", error);
    } finally {
      setPurchaseLoading(null); // Clear loading after attempt
    }
  };

  const completeTransaction = async (purchase: any) => {
    try {
      // For iOS, we need to call finishTransaction
      // if (Platform.OS === "ios") {
        const res = await finishTransaction({ purchase,isConsumable:true,developerPayloadAndroid:userData?._id });
        // await validateReceipt(purchase?.transactionReceipt);
        console.log("Transaction completed:", res);
      // }

      // In a real app, you would also verify the receipt with your server here
    } catch (error) {
      console.error("Error completing transaction:", error);
      throw error;
    }
  };
  return (
    <ImageBackground source={AppIcons.screenBackground} style={styles.mainView}>
      {/* Back Button */}
      <TouchableOpacity
        style={styles.backIcon}
        onPress={() => {
          navigation.goBack();
          userAction.setTouchSound(true);
        }}
      >
        <Image
          source={AppIcons.BackIcon}
          style={styles.backImage}
          resizeMode="contain"
        />
      </TouchableOpacity>
      <View style={styles.container}>
        <Text style={styles.title}>COINS</Text>
      </View>
      {loading ? (
        <View style={styles.loadingOverlay}>
          <ActivityIndicator size="large" color={AppTheme.colors.white} />
          <Text style={styles.loadingText}>Loading store...</Text>
        </View>
      ) : (
        <View style={styles.listContainer}>
          {products.map((item) => (
            <TouchableOpacity
              onPress={() => onBuyPress(item.productId)}
              activeOpacity={0.5}
              disabled={purchaseLoading === item.productId} // Disable during per-item loading
              key={item.productId}
              style={styles.itemWrapper}
            >
              <FastImage
                source={AppIcons.CoinBig}
                style={styles.coinImage}
                resizeMode={FastImage.resizeMode.contain}
              >
                {Platform.OS === "android" ? (
                  <Text style={styles.buyText}>
                    {item.title?.toLowerCase()?.split("coins")?.[0]?.trim()}{" "}
                    Coins
                  </Text>
                ) : (
                  <Text style={styles.title}>
                    {item.title?.replace(/"/g, "")}
                  </Text>
                )}
                <Image
                  source={AppIcons.Coin_5}
                  style={{ height: 150, width: 150 }}
                  resizeMode={"contain"}
                />
                <TouchableOpacity
                  activeOpacity={1}
                  style={{ alignSelf: "center", marginTop: -5 }}
                  disabled={purchaseLoading === item.productId} // Also disable inner touchable
                >
                  {purchaseLoading === item.productId ? (
                    <View style={styles.purchaseLoadingContainer}>
                      <ActivityIndicator
                        size="small"
                        color={AppTheme.colors.white}
                      />
                    </View>
                  ) : (
                    <LinearGradient
                      colors={[
                        AppTheme.colors.LinearGradient_13,
                        AppTheme.colors.LinearGradient_13,
                      ]}
                      start={{ x: 0, y: 0 }}
                      end={{ x: 1, y: 1 }}
                      style={styles.googleBtn1}
                    >
                      <LinearGradient
                        colors={[
                          AppTheme.colors.linearGradient_11,
                          AppTheme.colors.linearGradient_12,
                        ]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 1 }}
                        style={styles.googleBtn}
                      >
                        <Text style={styles.startText}>
                          {item.localizedPrice}
                        </Text>
                      </LinearGradient>
                    </LinearGradient>
                  )}
                </TouchableOpacity>
              </FastImage>
            </TouchableOpacity>
          ))}
        </View>
      )}
    </ImageBackground>
  );
};

export default InPurchaseScreenTablet;

const styles = StyleSheet.create({
  mainView: {
    flex: 1,
    alignItems: "center",
  },

  loadingText: {
    marginTop: 10,
    fontSize: 18,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
  },

  backIcon: {
    position: "absolute",
    top: 70,
    right: 0,
  },

  backImage: {
    width: 70,
    height: 55,
  },

  container: {
    marginTop: "18%",
    marginBottom: 40,
  },

  title: {
    alignSelf: "center",
    fontSize: 54,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },

  listContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    paddingBottom: 30,
  },

  itemWrapper: {
    width: "50%",
    alignItems: "center",
    marginVertical: 15,
  },

  coinImage: {
    width: "100%",
    height: 350,
    padding: 20,
    alignItems: "center",
    marginBottom: -10,
  },

  buyButton: {
    marginTop: 10,
    paddingHorizontal: 22,
    paddingVertical: 6,
    borderRadius: 20,
  },

  buyText: {
    paddingTop: 5,
    fontSize: Platform.OS == "android" ? 30 : 36,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  googleBtn: {
    width: Platform.OS == "ios" ? 180 : 200,
    height: 55,
    borderRadius: 360,
    justifyContent: "center",
  },

  googleBtn1: {
    width: Platform.OS == "ios" ? 180 : 200,
    height: 45,
    borderRadius: 360,
  },
  startText: {
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    fontSize: 23,
    color: AppTheme.colors.white,
    textAlign: "center",
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  purchaseLoadingContainer: {
    width: Platform.OS == "ios" ? 190 : 200,
    height: 55,
    borderRadius: 360,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.2)", // Semi-transparent background for spinner
  },
  loadingOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
});
